/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import noop from "lodash/fp/noop";
import { Grid, Icon } from "@material-ui/core";
import { Link } from "react-router-dom";
import ToggleStar from "src/components/atoms/inputs/ToggleStar";

import { SecondaryColorLabel } from "../../sharedStyles";
import {
  NotificationIndicatorFavourite,
  iconCss,
  iconContainerCss,
  innerContainerCss,
  labelCss,
  outerContainerCss,
  ToggleStarFavourite,
} from "./styles";
import { IconName, LinkTo, TemplateId } from "../../../../../../globalTypes";
import { OverviewTemplateRouteState } from "../../../../../../utils/internalLinksParsing";

const TemplateCardFavouriteView: FC<Props> = ({
  templateId,
  label,
  linkTo,
  onClick = noop,
  isFavourite,
  toggleFavourite,
  icon,
}) => (
  <div css={outerContainerCss}>
    <Link
      onClick={onClick}
      to={linkTo as LinkTo<unknown>}
      css={innerContainerCss}
    >
      <span css={iconContainerCss}>
        <Icon css={iconCss}>{icon}</Icon>
      </span>
      <SecondaryColorLabel css={labelCss}>{label}</SecondaryColorLabel>
    </Link>

    <ToggleStarFavourite>
      <ToggleStar active={isFavourite} onClick={toggleFavourite} />
    </ToggleStarFavourite>

    <NotificationIndicatorFavourite templateId={templateId} />
  </div>
);

type Props = {
  templateId: TemplateId;
  label: string;
  linkTo?: LinkTo<OverviewTemplateRouteState>;
  onClick?: () => void;
  isFavourite: boolean;
  toggleFavourite: () => void;
  icon: IconName;
};

export type TemplateCardFavouriteViewProps = Props;
export default TemplateCardFavouriteView;
